import { ITokenStrategy } from "@/interfaces/ITokenStrategy";

class NoTokenStrategyClass implements ITokenStrategy {
  appendTokenToParams(params: any) {
    return params;
  }
}

const NoTokenStrategy = new NoTokenStrategyClass();
export { NoTokenStrategy };
